import {LANGUAGE_RU} from "shared/language";
import {prepareEnvironment} from "./environment.prod.base";
import {ChatVersions} from "../../shared/chat.versions";
import translations from '../assets/i18n/ru.json';

const domain = 'virt-chat.net'
const prerenderDomain = 'ru.virt-chat.com'

export let environment = prepareEnvironment(LANGUAGE_RU, translations, domain, ChatVersions.VT, 'G-9P5STSZ51R', prerenderDomain)